export default "__VITE_ASSET__DxYBfqHQ__"